import Swiper from 'swiper';
import 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const SELECTORS = {
	filterItem: '.section-featured-content__resources-filter-item',
	resources: '.section-featured-content__resources',
	results: '.section-featured-content__resources-results',
	slider: '.section-featured-content__resources-slider',
	swiperSlider: '.js-featured-content-resources-slider',
	contentSlider: '.js-featured-content-resources-content-slider',
	sliderNav: '.slider-nav',
	pagination: '.swiper-pagination',
	slide: '.swiper-slide',
	resourceCard: '.section-featured-content__resource-card',
	resourceBody: '.section-featured-content__resource-card-body',
	nextButton: '.swiper-button-next',
	prevButton: '.swiper-button-prev',
};

const CLASSES = {
	active: 'is-active',
	loading: 'is-loading',
	swiperInitialized: 'swiper-initialized',
	swiperButtonDisabled: 'swiper-button-disabled',
};

const MOBILE_MEDIA_QUERY = '(max-width: 575.5px)';

const isMobileViewport = function() {
	return window.matchMedia( MOBILE_MEDIA_QUERY ).matches;
};

const RESOURCE_SLIDER_BREAKPOINTS = {
	576: {
		slidesPerView: 2,
	},
	768: {
		slidesPerView: 4,
	},
	1280: {
		slidesPerView: 6,
	},
	1440: {
		slidesPerView: 8,
	},
};
const CONTENT_SLIDER_BREAKPOINTS = {
	768: {
		slidesPerView: 2,
	},
	1024: {
		slidesPerView: 4,
	},
};

const getSwiper = function( $slider ) {
	return $slider[0] && $slider[0].swiper;
};

const setButtonDisabled = function( $button, isDisabled ) {
	$button
		.toggleClass( CLASSES.swiperButtonDisabled, isDisabled )
		.prop( 'disabled', isDisabled );
};

const initBlock = function( $block ) {
	$block.each( function() {
		const $sectionInstance = $( this );
		const $filterItems = $sectionInstance.find( SELECTORS.filterItem );
		let filterRequest = null;
		let isMovingToResource = false;

		const getResults = function() {
			return $sectionInstance.find( SELECTORS.results );
		};

		const getSlider = function() {
			return getResults().find( SELECTORS.slider );
		};

		const moveSliderToResource = function( swiper, slideIndex ) {
			const visibleSlidesCount = Math.max( 1, Math.floor( Number( swiper.params.slidesPerView ) || 1 ) );
			const maxStartIndex = Math.max( 0, swiper.slides.length - visibleSlidesCount );
			const currentStartIndex = swiper.activeIndex || 0;
			let nextStartIndex = currentStartIndex;

			if ( slideIndex < currentStartIndex ) {
				nextStartIndex = slideIndex;
			} else if ( slideIndex >= currentStartIndex + visibleSlidesCount ) {
				nextStartIndex = Math.min( slideIndex - visibleSlidesCount + 1, maxStartIndex );
			}

			if ( nextStartIndex !== currentStartIndex ) {
				isMovingToResource = true;
				swiper.slideTo( nextStartIndex, swiper.params.speed, false );

				setTimeout( function() {
					isMovingToResource = false;
				}, swiper.params.speed );
			}
		};

		const findResourceBody = function( $results, resourceId ) {
			return $results.find( SELECTORS.resourceBody ).filter( function() {
				return String( $( this ).data( 'resource-id' ) ) === String( resourceId );
			} );
		};

		const updateNavigationButtons = function( $slider, activeIndex ) {
			const $slides = $slider.find( SELECTORS.slide );
			const $resources = $slider.closest( SELECTORS.resources );
			const swiper = getSwiper( $slider );
			const shouldShowNavigation = !!swiper && !swiper.isLocked;

			$resources.find( SELECTORS.sliderNav ).prop( 'hidden', !shouldShowNavigation );

			setButtonDisabled( $resources.find( SELECTORS.prevButton ), !shouldShowNavigation || activeIndex <= 0 );
			setButtonDisabled( $resources.find( SELECTORS.nextButton ), !shouldShowNavigation || activeIndex >= $slides.length - 1 );
		};

		const activateResourceSlide = function( $slide, shouldMoveSlider = true ) {
			if ( !$slide.length ) {
				return;
			}

			const $slider = $slide.closest( SELECTORS.slider );
			const $results = $slide.closest( SELECTORS.results );
			const swiper = getSwiper( $slider );
			const resourceId = $slide.find( SELECTORS.resourceCard ).data( 'resource-id' );
			const slideIndex = $slide.index();

			$slider.find( SELECTORS.slide ).removeClass( CLASSES.active );
			$slide.addClass( CLASSES.active );
			$results.find( SELECTORS.resourceBody ).removeClass( CLASSES.active );
			findResourceBody( $results, resourceId ).addClass( CLASSES.active );
			updateNavigationButtons( $slider, slideIndex );

			if ( swiper && shouldMoveSlider ) {
				moveSliderToResource( swiper, slideIndex );
			}
		};

		const activateAdjacentResource = function( $slider, direction ) {
			const $slides = $slider.find( SELECTORS.slide );
			const $activeSlide = $slides.filter( `.${ CLASSES.active }` ).first();
			const currentIndex = $activeSlide.length ? $slides.index( $activeSlide ) : 0;
			const nextIndex = Math.max( 0, Math.min( $slides.length - 1, currentIndex + direction ) );

			if ( nextIndex === currentIndex ) {
				return;
			}

			activateResourceSlide( $slides.eq( nextIndex ) );
		};

		const activateInitialResourceSlide = function() {
			activateResourceSlide( getSlider().find( SELECTORS.slide ).first() );
		};

		const initResourcesSlider = function() {
			const $slider = $sectionInstance.find( SELECTORS.swiperSlider );

			if ( !$slider.length || $slider.data( CLASSES.swiperInitialized ) ) {
				return;
			}

			$slider.data( CLASSES.swiperInitialized, true );

			new Swiper( $slider[0], {
				slidesPerView: 1,
				spaceBetween: 20,
				speed: 1000,
				watchOverflow: true,
				breakpoints: RESOURCE_SLIDER_BREAKPOINTS,
				on: {
					slideChange: function() {
						if ( isMovingToResource ) {
							return;
						}

						activateResourceSlide( $( this.slides[this.activeIndex] ), false );
					},
					resize: function() {
						updateNavigationButtons( $( this.el ), this.activeIndex );
					},
					breakpoint: function() {
						updateNavigationButtons( $( this.el ), this.activeIndex );
					},
				},
			} );
		};

		const updateContentNavVisibility = function( swiper, $slider ) {
			const $nav = $slider.find( SELECTORS.sliderNav );
			const slidesPerView = typeof swiper.params.slidesPerView === 'number' ? swiper.params.slidesPerView : 1;
			const noOverflow = swiper.slides.length <= Math.ceil( slidesPerView );

			$nav.prop( 'hidden', noOverflow );
		};

		const initResourcesContentSlider = function() {
			const $slider = $sectionInstance.find( SELECTORS.contentSlider );

			if ( !$slider.length || $slider.data( CLASSES.swiperInitialized ) ) {
				return;
			}

			$slider.data( CLASSES.swiperInitialized, true );

			new Swiper( $slider[0], {
				slidesPerView: 1,
				spaceBetween: 20,
				speed: 1000,
				navigation: {
					nextEl: $slider.find( SELECTORS.nextButton )[0],
					prevEl: $slider.find( SELECTORS.prevButton )[0],
				},
				pagination: {
					el: $slider.find( SELECTORS.pagination )[0],
					clickable: true,
				},
				breakpoints: CONTENT_SLIDER_BREAKPOINTS,
				on: {
					init: function() {
						updateContentNavVisibility( this, $slider );
					},
					slideChange: function() {
						updateContentNavVisibility( this, $slider );
					},
					breakpoint: function() {
						updateContentNavVisibility( this, $slider );
					},
				},
			} );
		};

		$filterItems.off( 'click.featuredContent' ).on( 'click.featuredContent', function() {
			const $currentFilter = $( this );
			const resourceCategory = $currentFilter.data( 'resource-category' ) || '';
			const $currentResults = getResults();
			const currentSwiper = getSwiper( $currentResults.find( SELECTORS.slider ) );

			$filterItems.removeClass( CLASSES.active );
			$currentFilter.addClass( CLASSES.active );

			if ( filterRequest ) {
				filterRequest.abort();
			}

			$sectionInstance.addClass( CLASSES.loading );

			const currentRequest = $.ajax( {
				url: window.featuredContentAjaxParams.ajax_url,
				type: 'POST',
				data: {
					action: window.featuredContentAjaxParams.ajax_action,
					nonce: window.featuredContentAjaxParams.nonce,
					resourceCategory: resourceCategory,
				},
				success: function( response ) {
					if ( !response.success || !response.data.html ) {
						return;
					}

					if ( currentSwiper ) {
						currentSwiper.destroy( true, true );
					}

					$currentResults.replaceWith( response.data.html );
					initResourcesSlider();
					activateInitialResourceSlide();
				},
				complete: function() {
					if ( filterRequest === currentRequest ) {
						$sectionInstance.removeClass( CLASSES.loading );
						filterRequest = null;
					}
				},
			} );

			filterRequest = currentRequest;
		} );

		$sectionInstance
			.off( 'click.featuredContentResource', SELECTORS.resourceCard )
			.on( 'click.featuredContentResource', SELECTORS.resourceCard, function( event ) {
				if ( !isMobileViewport() ) {
					event.preventDefault();
				}

				activateResourceSlide( $( this ).closest( SELECTORS.slide ) );
			} );

		$sectionInstance
			.off( 'click.featuredContentResourceNav', `${ SELECTORS.nextButton }, ${ SELECTORS.prevButton }` )
			.on( 'click.featuredContentResourceNav', `${ SELECTORS.nextButton }, ${ SELECTORS.prevButton }`, function( event ) {
				const $button = $( this );
				const $resources = $button.closest( SELECTORS.resources );

				if ( !$resources.length ) {
					return;
				}

				const $slider = $resources.find( SELECTORS.results ).find( SELECTORS.slider );
				const direction = $button.is( SELECTORS.nextButton ) ? 1 : -1;

				event.preventDefault();

				activateAdjacentResource( $slider, direction );
			} );

		initResourcesSlider();
		initResourcesContentSlider();
		activateInitialResourceSlide();
	} );
};

app.loadBlock( initBlock, 'featured-content', '.section-featured-content' );

if ( module.hot ) {
	module.hot.accept();
}
